import XLSX from "xlsx"

export const jsonToSheet = (data, nameFile = "sheet") => {
  const ws = XLSX.utils.json_to_sheet(data)
  const wb = XLSX.utils.book_new()
  XLSX.utils.book_append_sheet(wb, ws, "SheetJS")
  XLSX.writeFile(wb, `${nameFile}.xlsx`)
}
